import React, { useRef } from "react";
import { Modal, Row, Col, Popconfirm, Button } from "antd";
import { PlusOutlined, FilePdfOutlined, FileImageOutlined, FileTextOutlined } from "@ant-design/icons";
import { ReactComponent as DeleteIcon } from "../../../../assets/delete-icon.svg";
import SpinnerComponent from "../../../../components/spinner";

const AttachmentsListModal = ({ 
  visible,
  onClose,
  attachments = [],
  onShowImage,
  onDeleteImage,
  delAttachKey = [],
  title = "ATTACHMENTS",
  onUpload,
  uploading = false,
  useShippingIcon = false,
  canAdd = true
}) => {
  const inputFile = useRef(null);

  // Function to check if file is PDF
  const isPdfFile = (filename) => {
    if (!filename) return false;
    return filename.toLowerCase().endsWith('.pdf');
  };

  // Function to check if file is an image
  const isImageFile = (filename) => {
    if (!filename) return false;
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
  };

  // Function to check if file is a document
  const isDocumentFile = (filename) => {
    if (!filename) return false;
    const docExtensions = ['.doc', '.docx', '.txt', '.rtf'];
    return docExtensions.some(ext => filename.toLowerCase().endsWith(ext));
  };

  // Function to get file icon based on file type
  const getFileIcon = (filename) => {
    if (isPdfFile(filename)) {
      return <FilePdfOutlined style={{ color: '#ff4d4f', fontSize: '16px' }} />;
    }
    if (isImageFile(filename)) {
      return <FileImageOutlined style={{ color: '#52c41a', fontSize: '16px' }} />;
    }
    if (isDocumentFile(filename)) {
      return <FileTextOutlined style={{ color: '#1890ff', fontSize: '16px' }} />;
    }
    return null;
  };
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      bodyStyle={{ overflowY: 'auto', overflowX: 'hidden'  }}
    >
      {attachments.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
          No Attachments Found
        </div>
      ) : (
        <Row gutter={[20, 10]} className="attach-listing-div">
          {attachments.map((el, index) => (
            <Col span={24} key={el.key || el.id || index}>
              <Row justify="space-between" align="middle">
                <Col
                  onClick={() => onShowImage(el)}
                  className="name-col"
                  flex="1"
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {getFileIcon(el.originalName || el.name)}
                    <span className="name" style={{ wordBreak: 'break-all' }}>
                      {(el.originalName || el.name)?.replaceAll(/[^a-zA-Z0-9.-]/g, " ")}
                    </span>
                  </div>
                </Col>
                {!useShippingIcon && canAdd && (
                  <Col flex="none">
                    {delAttachKey.includes(el?.key || el?.id) ? (
                      <SpinnerComponent fontSize={14} />
                    ) : (
                      <Popconfirm
                        title="Are you sure you want to delete this Attachment?"
                        onConfirm={() => onDeleteImage(el)}
                        okText="Yes"
                        cancelText="No"
                      >

                      <DeleteIcon className="del-icon" style={{ cursor: 'pointer' }} />

                      </Popconfirm>
                    )}
                  </Col>
                )}
              </Row>
            </Col>
          ))}
        </Row>
      )}

      {!useShippingIcon && canAdd && (
        <div style={{ marginTop: '28px', marginBottom: '16px', textAlign: 'center' }}>
          <input
            disabled={uploading}
            type="file"
            name="modalAttachment"
            id="modalAttachment"
            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.jpeg,.gif,.png,.mp4"
            style={{ display: "none" }}
            onChange={onUpload}
            multiple
            ref={inputFile}
          />
          <Button
            icon={<PlusOutlined />}
            className="add-activity-btn"
            size="middle"
            onClick={() => inputFile.current.click()}
            loading={uploading}
          >
           Attachments
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default AttachmentsListModal;
